module.exports = __webpack_public_path__ + "img/AVI.b30588a1.png";